<template>
  <basic-modal.container
    id="softlogin"
    ref="softloginModalRef"
    is-alert
  >
    <component
      :is="currentStep.component"
      :data="currentStep.prevStepData"

      @cancel="cancelLogin"
      @finish="finishLogin"

      @next="gotoNextStep"
      @prev="gotoPrevStep"
    />
  </basic-modal.container>
</template>

<script setup>
  import { computed, onBeforeMount, shallowRef, useTemplateRef } from 'vue'

  import { events$ } from '@shared/services'
  import { ReactivityUtil } from '@shared/utils/Reactivity'

  import useSoftlogin from '@shared/hooks/useSoftlogin'

  import { BasicModal } from '@shared/components/Basic'

  import { EVENT_LOGIN } from '@shared/config/events'
  import { CHANNEL } from '@shared/config/constants'

  import { SOFTLOGIN_STEP_MAP } from '@shared/components/Softlogin/config'

  // HOOKS
  const { basket, channel, setTemporaryBasket } = useSoftlogin()

  // DATA
  let closeCallback
  const modalRef = useTemplateRef('softloginModalRef')
  const currentStep = shallowRef({})

  // COMPUTED
  const currentIndex = computed(() => {
    return getMapFromChannel.value.findIndex(s => s.name === currentStep.value.name)
  })

  const getMapFromChannel = computed(() => {
    switch (channel.value) {
      case CHANNEL.OVP:
      case CHANNEL.ENTRYWIDGET:
      case CHANNEL.PRODUCTWIDGET:
      default:
        return SOFTLOGIN_STEP_MAP.DVP

      case CHANNEL.PARTNER_PORTAL:
        return SOFTLOGIN_STEP_MAP.PARTNER

      case CHANNEL.PORTAL_WEB:
      case CHANNEL.PORTAL_APP:
        return SOFTLOGIN_STEP_MAP.PORTAL

      case 'ios':
      case 'android':
      case 'web':
        return SOFTLOGIN_STEP_MAP.PORTAL_LEGACY
    }
  })

  const nextStepFromMap = computed(() => {
    return getMapFromChannel.value[currentIndex.value + 1]
  })

  const prevStepFromMap = computed(() => {
    return getMapFromChannel.value[currentIndex.value - 1]
  })

  // METHODS
  function cancelLogin() {
    setTemporaryBasket({})

    modalRef.value.close()
  }

  function finishLogin() {
    // @note: if closeCallback is defined, call it after closing modal
    if (closeCallback) closeCallback(basket)

    events$.emit(EVENT_LOGIN.AUTHENTICATED, basket)

    modalRef.value.close()
  }

  function getStepByName(name) {
    return getMapFromChannel.value.find(s => s.name === name)
  }

  function gotoNextStep(data = {}) {
    // @note: if `nextStep` is passed, use it to set current step
    if (data.nextStep) {
      currentStep.value = getStepByName(data.nextStep)
    } else {
      currentStep.value = nextStepFromMap.value
    }

    currentStep.value.prevStepData = data
  }

  function gotoPrevStep(data = {}) {
    // @note: if `prevStep` is passed, use it to set curret step
    if (data.prevStep) {
      currentStep.value = getStepByName(data.prevStep)
    } else {
      currentStep.value = prevStepFromMap.value
    }

    currentStep.value.prevStepData = ReactivityUtil.clone(currentStep.value?.prevStepData)
  }

  function openModal(opts) {
    if (opts.callback) closeCallback = opts.callback
    if (opts.channel) channel.value = opts.channel

    currentStep.value = getMapFromChannel.value[0]

    modalRef.value.open()
  }

  // LIFECYCLE HOOKS
  onBeforeMount(() => {
    events$.on(EVENT_LOGIN.OPEN, openModal)
  })
</script>

<style scoped>

</style>
